import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import AddStoreBlockDate from './AddStoreBlockDate'

class StoreBlockDateAddTab extends React.Component {
    state = {
        language_data: [],
    }

    componentDidMount() {
        if (
            this.props.match.params.store_block_date_id !== undefined &&
            this.props.match.params.store_block_date_id !== null &&
            this.props.match.params.store_block_date_id !== 0 &&
            this.props.match.params.store_block_date_id !== ''
        ) {
            this.setState({ store_block_date_id: this.props.match.params.store_block_date_id })
        }
        this.getLanguageList()
    }

    getLanguageList = () => {
        var language_data = Constant.getLanguageList()
        this.setState({
            language_data: language_data,
            language_id: language_data[0].id,
            isLoading: false,
        })
    }

    handleLanguage = (language_id) => {
        this.setState({ language_id: language_id })
    }

    render() {
        return (
            <div className="main-body">
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row align-items-end">
                            <div className="col-lg-8">
                                <div className="page-header-title">
                                    <div className="d-inline">
                                        <h4>
                                            Store Block Date {this.props.match.params.store_block_date_id ? 'Edit' : 'Add'}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="page-header-breadcrumb">
                                    <ul className="breadcrumb-title">
                                        <li className="breadcrumb-item">
                                            <Link to="/">
                                                <i className="feather icon-home"></i>{' '}
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link
                                                to={`/store-details/${this.props.match.params.storeId}/store-block-date-lists`}
                                            >
                                                Store Block Date List
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active">
                                            {this.props.match.params.store_block_date_id ? 'Edit' : 'Add'} Block Date
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-body">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card card-border-default">
                                    <div className="card-block">
                                        <div className="tab-content tabs">
                                            <div
                                                className="tab-pane  active"
                                                id={'Store_block_date_add_' + this.state.language_id}
                                                role="tabpanel"
                                                aria-labelledby=""
                                            >
                                                {this.state.store_block_date_id !== undefined &&
                                                    this.state.store_block_date_id !== null &&
                                                    this.state.store_block_date_id !== 0 &&
                                                    this.state.store_block_date_id !== '' ? (
                                                    <AddStoreBlockDate
                                                        goBack={this.props.history.goBack}
                                                        storeId={this.props.match.params.storeId}
                                                        store_block_date_id={this.state.store_block_date_id}
                                                    />
                                                ) : (
                                                    <AddStoreBlockDate
                                                        language_id={this.state.language_id}
                                                        storeId={this.props.match.params.storeId}
                                                        goBack={this.props.history.goBack}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StoreBlockDateAddTab
